export const getId = state => state.id;
export const getUserId = state => state.userId;
export const getGladlyCustomerId = state => state.gladlyCustomerId;
export const getName = state => state.name;
export const getEmail = state => state.email;
export const getCredentials = state => {
  return { token: state.token, userId: state.userId };
};
export const getHasUserOnboarded = state => state.hasOnboarded;

export default {
  getCredentials,
  getId,
  getUserId,
  getGladlyCustomerId,
  getName,
  getEmail,
  getHasUserOnboarded,
};
